import { render, staticRenderFns } from "./GuncellemelerInfo.vue?vue&type=template&id=4c219b36"
import script from "./GuncellemelerInfo.vue?vue&type=script&lang=ts"
export * from "./GuncellemelerInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports